var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-variant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8325 13.6525C11.2425 14.0425 11.2425 14.6825 10.8325 15.0725C10.4425 15.4625 9.8025 15.4625 9.4125 15.0725C7.4625 13.1225 7.4625 9.9525 9.4125 8.0025L12.9525 4.4625C14.9025 2.5125 18.0725 2.5125 20.0225 4.4625C21.9725 6.4125 21.9725 9.5825 20.0225 11.5325L18.5325 13.0225C18.5425 12.2025 18.4125 11.3825 18.1325 10.6025L18.6025 10.1225C19.7825 8.9525 19.7825 7.0525 18.6025 5.8825C17.4325 4.7025 15.5325 4.7025 14.3625 5.8825L10.8325 9.4125C9.6525 10.5825 9.6525 12.4825 10.8325 13.6525ZM13.6525 9.4125C14.0425 9.0225 14.6825 9.0225 15.0725 9.4125C17.0225 11.3625 17.0225 14.5325 15.0725 16.4825L11.5325 20.0225C9.5825 21.9725 6.4125 21.9725 4.4625 20.0225C2.5125 18.0725 2.5125 14.9025 4.4625 12.9525L5.9525 11.4625C5.9425 12.2825 6.0725 13.1025 6.3525 13.8925L5.8825 14.3625C4.7025 15.5325 4.7025 17.4325 5.8825 18.6025C7.0525 19.7825 8.9525 19.7825 10.1225 18.6025L13.6525 15.0725C14.8325 13.9025 14.8325 12.0025 13.6525 10.8325C13.2425 10.4425 13.2425 9.8025 13.6525 9.4125Z",
    fill: "#018385"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.bc9abf6f4828683a01643f044999a049.svg";
export { ForwardRef as ReactComponent };